import { useState } from 'react';
import { toggleTheme } from '../styles/theme';

export function ThemeToggle() {
  const [theme, setTheme] = useState(
    () => (document.documentElement.getAttribute('data-theme') as 'light' | 'dark' | null) ?? 'light',
  );

  function onClick() {
    toggleTheme();
    const next = document.documentElement.getAttribute('data-theme') as 'light' | 'dark' | null;
    setTheme(next ?? 'light');
  }

  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className="icon-btn"
      onClick={onClick}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? (
        // Sun icon
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
        </svg>
      ) : (
        // Moon icon
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
        </svg>
      )}
    </button>
  );
}
